import * as React from "react";
type Ctx = { open: boolean; setOpen: (v: boolean) => void };
const C = React.createContext<Ctx | null>(null);
export function GlobalSearchProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = React.useState(false);
  return <C.Provider value={{ open, setOpen }}>{children}</C.Provider>;
}
export const useGlobalSearch = () => {
  const ctx = React.useContext(C);
  if (!ctx) throw new Error("useGlobalSearch outside provider");
  return ctx;
};
